module.exports = __webpack_public_path__ + "static/img/关键条款检测_产品截图_image@2x.8bf3dd15.png";